import { motion, AnimatePresence } from "framer-motion";
import { WifiOff, Wifi, CloudOff, RefreshCw } from "lucide-react";
import { useOfflineStatus } from "@/hooks/useOfflineStatus";
import { Button } from "@/components/ui/button";

export const OfflineIndicator = () => {
  const { isOnline, isReconnecting, pendingSync, retryConnection } = useOfflineStatus();

  return (
    <AnimatePresence>
      {!isOnline && (
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed top-0 left-0 right-0 z-[100] safe-area-top"
        >
          <div className="bg-warning/95 backdrop-blur-sm px-4 py-3 shadow-lg">
            <div className="container mx-auto flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <motion.div
                  animate={{ scale: [1, 1.1, 1] }}
                  transition={{ duration: 2, repeat: Infinity }}
                >
                  {isReconnecting ? (
                    <RefreshCw className="w-5 h-5 text-warning-foreground animate-spin" />
                  ) : (
                    <WifiOff className="w-5 h-5 text-warning-foreground" />
                  )}
                </motion.div>
                <div>
                  <p className="text-sm font-medium text-warning-foreground">
                    {isReconnecting ? "Reconectando..." : "Você está offline"}
                  </p>
                  {pendingSync > 0 && (
                    <p className="text-xs text-warning-foreground/80">
                      {pendingSync} alteração(ões) pendente(s) para sincronizar
                    </p>
                  )}
                </div>
              </div>
              
              {!isReconnecting && (
                <Button
                  size="sm"
                  variant="secondary"
                  onClick={retryConnection}
                  className="bg-warning-foreground/20 hover:bg-warning-foreground/30 text-warning-foreground border-0"
                >
                  <RefreshCw className="w-4 h-4 mr-1" />
                  Tentar novamente
                </Button>
              )}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

// Toast notification for reconnection
export const OnlineToast = () => {
  const { justReconnected } = useOfflineStatus();

  return (
    <AnimatePresence>
      {justReconnected && (
        <motion.div
          initial={{ y: 50, opacity: 0, scale: 0.9 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 50, opacity: 0, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
          className="fixed bottom-24 left-1/2 -translate-x-1/2 z-[100]"
        >
          <div className="bg-success/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg flex items-center gap-2">
            <Wifi className="w-4 h-4 text-success-foreground" />
            <span className="text-sm font-medium text-success-foreground">
              Conexão restaurada!
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
